import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtil } from '../utils/http-util';
import { Paged } from '../models/shared/paged';
import { GetApprovalRequest, GetApprovedRequest, GetRejectedRequest } from '../models/approval/approval';

@Injectable({ providedIn: 'root' })
export class ApprovalService {
  private http = inject(HttpClient);
  private apiBaseUrl = environment.api.url;
  private base = `${this.apiBaseUrl}/Approval`;

  getPendingRequests(filter?: { page?: number; pageSize?: number; startDate?: string; endDate?: string, filterKey?: string, filterValue?: string }): Observable<Paged<GetApprovalRequest>> {
    return this.http.get<Paged<GetApprovalRequest>>(`${this.base}/requests`, {
      params: HttpUtil.toHttpParams(filter ?? {})
    });
  }

  getApprovedRequests(filter?: { paymentStatusId?: number; page?: number; pageSize?: number, startDate?: string; endDate?: string, filterKey?: string, filterValue?: string }): Observable<Paged<GetApprovedRequest>> {
    return this.http.get<Paged<GetApprovedRequest>>(`${this.base}/approved`, {
      params: HttpUtil.toHttpParams(filter ?? {})
    });
  }

  getRejectedRequests(filter?: { page?: number; pageSize?: number, startDate?: string; endDate?: string, filterKey?: string, filterValue?: string }): Observable<Paged<GetRejectedRequest>> {
    return this.http.get<Paged<GetRejectedRequest>>(`${this.base}/rejected`, {
      params: HttpUtil.toHttpParams(filter ?? {})
    });
  }

  approveRequest(data: { requestId: number; }): Observable<void> {
    return this.http.post<void>(`${this.base}/approve`, data);
  }

  rejectRequest(data: { requestId: number; rejectionReason: string }): Observable<void> {
    return this.http.post<void>(`${this.base}/reject`, data);
  }
}
